module.exports = __webpack_public_path__ + "img/logo-text-black.21dd3e88.png";